module.exports = __webpack_public_path__ + "static/media/Step3.2d7af2fe.png";